import React from "react";
import NoData from "@/components/NoData";
import { useMatchInfo } from "./MatchInfoContext";
import RecentLeaderBoardContainer from "@/components/RecentLeaderBoardContainer";
import CollapsiblePanel from "@/components/CollapsiblePanel";

const renderNoData = () => {
  return (
    <CollapsiblePanel
      title="Thành tích gần đây"
    >
      <NoData />
    </CollapsiblePanel>
  );
};

const RecentLeaderBoard = () => {
  const { matchAnalysis, matchFormStats, matchGoalStats, matchOddStats, match } = useMatchInfo();

  if (!matchFormStats || matchFormStats?.success == false) {
    return renderNoData();
  }

  if (!matchAnalysis || matchAnalysis.length === 0) {
    return renderNoData();
  }

  if (!matchFormStats || matchFormStats.length === 0) {
    return renderNoData();
  }

  if (!match) {
    return renderNoData();
  }

  const { homeId, awayId, leagueId } = matchAnalysis;

  const home = {
    id: homeId,
    name: matchAnalysis?.homeTeam?.name,
    logo: matchAnalysis?.homeTeam?.logo,
  };

  const away = {
    id: awayId,
    name: matchAnalysis?.awayTeam?.name,
    logo: matchAnalysis?.awayTeam?.logo,
  };
  
  return (
    <div className="text-[var(--theme-text)] bg-[var(--theme-bg)]">
    <RecentLeaderBoardContainer
      leagueId={leagueId}
      home={home}
      away={away}
      formStats={matchFormStats}
      goalStats={matchGoalStats}
      oddStats={matchOddStats}
      match={match}
    />
    </div>
  );
};

export default RecentLeaderBoard;
